module.exports = __webpack_public_path__ + "static/media/children-over.ec87966d.svg";